import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import TopBar from '../../../global/TopBar';

const AddDish = () => {
  const { restaurantId } = useParams();
  const navigate = useNavigate();
  const [dish, setDish] = useState({
    name: '',
    price: '',
    description: '',
    category: '',
    image: ''
  });

  const handleChange = (e) => {
    setDish({ ...dish, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Implement API call to add dish
    navigate(`/food/restaurant/${restaurantId}/manage/dishes`);
  };

  return (
    <>
      <TopBar />
      <div className="container mx-auto px-4 py-8 text-white">
        <h1 className="text-3xl font-bold mb-8">Add New Dish</h1>
        <form onSubmit={handleSubmit} className="bg-sec-dark p-6 rounded-lg shadow-md">
          <div className="mb-4">
            <label htmlFor="name" className="block text-sm font-medium mb-1">Name</label>
            <input type="text" id="name" name="name" value={dish.name} onChange={handleChange} required className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-md text-white" />
          </div>
          <div className="mb-4">
            <label htmlFor="price" className="block text-sm font-medium mb-1">Price</label>
            <input type="number" id="price" name="price" value={dish.price} onChange={handleChange} required className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-md text-white" />
          </div>
          <div className="mb-4">
            <label htmlFor="description" className="block text-sm font-medium mb-1">Description</label>
            <textarea id="description" name="description" value={dish.description} onChange={handleChange} required className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-md text-white"></textarea>
          </div>
          <div className="mb-4">
            <label htmlFor="category" className="block text-sm font-medium mb-1">Category</label>
            <input type="text" id="category" name="category" value={dish.category} onChange={handleChange} required className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-md text-white" />
          </div>
          <div className="mb-4">
            <label htmlFor="image" className="block text-sm font-medium mb-1">Image URL</label>
            <input type="url" id="image" name="image" value={dish.image} onChange={handleChange} required className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded-md text-white" />
          </div>
          <button type="submit" className="bg-pri-yellow text-pri-dark font-semibold py-2 px-4 rounded-md hover:bg-opacity-80 transition-colors duration-200">
            Add Dish
          </button>
        </form>
      </div>
    </>
  );
};

export default AddDish;